import type { ISymbolGraphicAttribute } from '@visactor/vrender-core';
import { Symbol } from '@visactor/vrender-core';

export class PlayerIcon extends Symbol {
  constructor(params: ISymbolGraphicAttribute) {
    super(params);
  }
}
